import { render, staticRenderFns } from "./InspectorSelector.vue?vue&type=template&id=0c0812a5&"
import script from "./InspectorSelector.vue?vue&type=script&lang=js&"
export * from "./InspectorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports